import React from "react";
import { SiteHeader } from "./SiteHeader";
import "./LandingGrid.css";
import "./ContactPage.css";

const year = new Date().getFullYear();

const CONTACTS = [
  {
    label: "Name",
    value: "Alessandro Giustini",
  },
  {
    label: "Email",
    value: "hello@alessandrogiustini.com",
    href: "mailto:hello@alessandrogiustini.com",
  },
  {
    label: "WhatsApp",
    value: "+39 339 738 5380",
    href: "https://wa.me/393397385380",
  },
  {
    label: "Instagram",
    value: "@ag.lunatik",
    href: "https://www.instagram.com/ag.lunatik/",
  },
];

export default function ContactPage() {
  return (
    <div className="lg-page">
      <section className="lg-root contact-root" aria-label="Contact">
        <div className="lg-grid-bg" aria-hidden="true" />

        <SiteHeader />

        <div className="lg-divider" aria-hidden="true" />
        <p className="lg-vertical contact-vertical">
          ORIGINAL SCORE · SOUND DESIGN · LIVE PERFORMANCE
        </p>

        <main className="contact-main">
          <div className="contact-copy">
            <p className="lg-section-kicker">
              <span>04</span>
              <span className="lg-section-kicker-rule" aria-hidden="true" />
              <span>CONTACT</span>
            </p>

            <h1 className="contact-title">
              Let&apos;s
              <br />
              talk.
            </h1>

            <ul className="contact-list">
              {CONTACTS.map((item) => (
                <li key={item.label}>
                  <span>{item.label}</span>
                  {item.href ? (
                    <a
                      href={item.href}
                      target={item.href.startsWith("http") ? "_blank" : undefined}
                      rel="noreferrer"
                    >
                      {item.value}
                    </a>
                  ) : (
                    <strong>{item.value}</strong>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="contact-grid-panel">
            <div className="contact-grid-panel-bg" aria-hidden="true" />
            <span className="lg-cross contact-cross--a" aria-hidden="true">
              +
            </span>
            <span className="lg-cross contact-cross--b" aria-hidden="true">
              +
            </span>
            <span className="lg-cross contact-cross--c" aria-hidden="true">
              +
            </span>
            <span className="lg-cross contact-cross--d" aria-hidden="true">
              +
            </span>
            <span className="lg-cross contact-cross--e" aria-hidden="true">
              +
            </span>
            <span className="lg-cross contact-cross--f" aria-hidden="true">
              +
            </span>
            <div className="lg-footer contact-footer">
              <span className="lg-footer-rule" aria-hidden="true" />
              <span className="lg-copy">©{year}</span>
            </div>
          </div>
        </main>
      </section>
    </div>
  );
}
